import React, { useEffect, useState } from "react";

import { DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";

import { DetailsViewData } from "../../../../../../../../models";
import { Locale } from "../../../../../../../../utils/localization";
import { DetailsViewComponent } from "../../../../../../../components";
import { useCustomerMissionCodesData } from "../../../../../../../../hooks";
import { EditFieldTypeConst } from "../../../../../../../../constants";

export const CustomerMissionTab = (props: any) => {
  const {
    isEditing,
    evDetailsTabSelected,
    basicSiteDetails,
    isBasicSiteDetailsLoading,

    onPatchRequestValueSet,
    onSectionValueSet,

    isSectionValueChanged,
    onSectionValueChanged,
    sectionEditedData,
    isCreate,
  } = props;

  const [siteCustomerMissionData, setSiteCustomerMissionData] = useState<
    DetailsViewData[]
  >([]);
  const [customerPrimaryMission, setCustomerPrimaryMission] = useState<any>();
  const [customerSecondaryMission, setCustomerSecondaryMission] =
    useState<any>();
  const [customerTertiaryMission, setCustomerTertiaryMission] = useState<any>();
  const [customerQuaternaryMission, setCustomerQuaternaryMission] =
    useState<any>();

  const {
    isLoading: isCustomerMissionCodesLoading,
    data: customerMissionCodes,
    refetch: refetchCustomerMissionCodes,
  } = useCustomerMissionCodesData();

  useEffect(() => {
    if (evDetailsTabSelected === 4 && isEditing) {
      refetchCustomerMissionCodes();
    }
  }, [evDetailsTabSelected, isEditing]);

  const onCustomerPrimaryMissionChange = (event: DropDownListChangeEvent) => {
    onSectionValueChanged(true);
    const primaryMission = event.target.value;
    setCustomerPrimaryMission(primaryMission);
    onSectionValueSet({
      customerPrimaryMission: primaryMission,
    });
    onPatchRequestValueSet(
      {
        customerMissionPrimaryCd: {
          customerMissionPrimaryCd: primaryMission.value,
        },
      },
      basicSiteDetails?.customerMissionPrimaryCd?.customerMissionPrimaryCd !==
        primaryMission.value
    );
  };

  const onCustomerSecondaryMissionChange = (event: DropDownListChangeEvent) => {
    onSectionValueChanged(true);
    const secondaryMission = event.target.value;
    setCustomerSecondaryMission(secondaryMission);
    onSectionValueSet({
      customerSecondaryMission: secondaryMission,
    });
    onPatchRequestValueSet(
      {
        customerMissionSecondaryCd: {
          customerMissionSecondaryCd: secondaryMission?.value,
        },
      },
      basicSiteDetails?.customerMissionSecondaryCd
        ?.customerMissionSecondaryCd !== secondaryMission.value
    );
  };

  const onCustomerTertiaryMissionChange = (event: DropDownListChangeEvent) => {
    onSectionValueChanged(true);
    const tertiaryMission = event.target.value;
    setCustomerTertiaryMission(tertiaryMission);
    onSectionValueSet({
      customerTertiaryMission: tertiaryMission,
    });
    onPatchRequestValueSet(
      {
        customerMissionTertiaryCd: {
          customerMissionTertiaryCd: tertiaryMission?.value,
        },
      },
      basicSiteDetails?.customerMissionTertiaryCd?.customerMissionTertiaryCd !==
        tertiaryMission.value
    );
  };

  const onCustomerQuaternaryMissionChange = (
    event: DropDownListChangeEvent
  ) => {
    onSectionValueChanged(true);
    const quaternaryMission = event.target.value;
    setCustomerQuaternaryMission(quaternaryMission);
    onSectionValueSet({
      customerQuaternaryMission: quaternaryMission,
    });
    onPatchRequestValueSet(
      {
        customerMissionQuaternaryCd: {
          customerMissionQuaternaryCd: quaternaryMission.value,
        },
      },
      basicSiteDetails?.customerMissionQuaternaryCd
        ?.customerMissionQuaternaryCd !== quaternaryMission.value
    );
  };

  useEffect(() => {
    if ((sectionEditedData && isSectionValueChanged) || basicSiteDetails) {
      setCustomerPrimaryMission(
        sectionEditedData?.customerPrimaryMission || {
          id: basicSiteDetails?.customerMissionPrimaryCd
            ?.customerMissionPrimaryCd,
          value:
            basicSiteDetails?.customerMissionPrimaryCd
              ?.customerMissionPrimaryCd,
        }
      );
      setCustomerSecondaryMission(
        sectionEditedData?.customerSecondaryMission || {
          id: basicSiteDetails?.customerMissionSecondaryCd
            ?.customerMissionSecondaryCd,
          value:
            basicSiteDetails?.customerMissionSecondaryCd
              ?.customerMissionSecondaryCd,
        }
      );
      setCustomerTertiaryMission(
        sectionEditedData?.customerTertiaryMission || {
          id: basicSiteDetails?.customerMissionTertiaryCd
            ?.customerMissionTertiaryCd,
          value:
            basicSiteDetails?.customerMissionTertiaryCd
              ?.customerMissionTertiaryCd,
        }
      );
      setCustomerQuaternaryMission(
        sectionEditedData?.customerQuaternaryMission || {
          id: basicSiteDetails?.customerMissionQuaternaryCd
            ?.customerMissionQuaternaryCd,
          value:
            basicSiteDetails?.customerMissionQuaternaryCd
              ?.customerMissionQuaternaryCd,
        }
      );
    }
  }, [sectionEditedData, basicSiteDetails]);

  useEffect(() => {
    const customerMissionData: DetailsViewData[] = [
      {
        label:
          Locale.site_details?.ev_details.customer_mission
            .Primary_customer_mission,
        value:
          basicSiteDetails?.customerMissionPrimaryCd?.customerMissionPrimaryCd,
        editType: EditFieldTypeConst.DROPDOWN_FIELD,
        onChange: onCustomerPrimaryMissionChange,
        editValue: customerPrimaryMission,
        isEditDataLoading: isCustomerMissionCodesLoading,
        editData: customerMissionCodes?.filter((mission: any) => {
          return (
            mission?.id !== customerSecondaryMission?.id &&
            mission?.id !== customerTertiaryMission?.id &&
            mission?.id !== customerQuaternaryMission?.id
          );
        }),
        isVisible: true,
      },
      {
        label:
          Locale.site_details?.ev_details.customer_mission
            .secondary_customer_mission,
        value:
          basicSiteDetails?.customerMissionSecondaryCd
            ?.customerMissionSecondaryCd,
        editType: EditFieldTypeConst.DROPDOWN_FIELD,
        onChange: onCustomerSecondaryMissionChange,
        isEditDataLoading: isCustomerMissionCodesLoading,
        editData: customerMissionCodes?.filter((mission: any) => {
          return (
            mission?.id !== customerPrimaryMission?.id &&
            mission?.id !== customerTertiaryMission?.id &&
            mission?.id !== customerQuaternaryMission?.id
          );
        }),
        editValue: customerSecondaryMission,
        isVisible: true,
      },
      {
        label:
          Locale.site_details?.ev_details.customer_mission
            .tertiary_customer_mission,
        value:
          basicSiteDetails?.customerMissionTertiaryCd
            ?.customerMissionTertiaryCd,
        editType: EditFieldTypeConst.DROPDOWN_FIELD,
        onChange: onCustomerTertiaryMissionChange,
        isEditDataLoading: isCustomerMissionCodesLoading,
        editData: customerMissionCodes?.filter((mission: any) => {
          return (
            mission?.id !== customerPrimaryMission?.id &&
            mission?.id !== customerSecondaryMission?.id &&
            mission?.id !== customerQuaternaryMission?.id
          );
        }),
        editValue: customerTertiaryMission,
        isVisible: true,
      },
      {
        label:
          Locale.site_details?.ev_details.customer_mission
            .quaternary_customer_mission,
        value:
          basicSiteDetails?.customerMissionQuaternaryCd
            ?.customerMissionQuaternaryCd,
        editType: EditFieldTypeConst.DROPDOWN_FIELD,
        onChange: onCustomerQuaternaryMissionChange,
        isEditDataLoading: isCustomerMissionCodesLoading,
        editData: customerMissionCodes?.filter((mission: any) => {
          return (
            mission?.id !== customerPrimaryMission?.id &&
            mission?.id !== customerSecondaryMission?.id &&
            mission?.id !== customerTertiaryMission?.id
          );
        }),
        editValue: customerQuaternaryMission,
        isVisible: true,
      },
      { label: "", value: "", isVisible: true },
    ];
    setSiteCustomerMissionData(customerMissionData);
  }, [
    basicSiteDetails,
    customerPrimaryMission,
    customerSecondaryMission,
    customerTertiaryMission,
    customerQuaternaryMission,
    customerMissionCodes,
    isEditing,
    evDetailsTabSelected,
  ]);

  return (
    <DetailsViewComponent
      data={siteCustomerMissionData}
      classValue="mdm--row mdm--sd-data customer-mission"
      isLoading={isBasicSiteDetailsLoading}
      isEditing={isEditing}
      isCreate={isCreate}
    />
  );
};
